<template>
    
    <div>

        <div v-if="error" class='alert alert-danger'>
            {{error}}
        </div>

        <!-- <div>userInfo: <pre>{{userInfo}}</pre></div>
        <div>buyerInfo o: <pre>{{buyerInfo}}</pre></div>
        <div>paymentOption<pre>{{paymentOption}}</pre></div> -->


        <div v-if="buyerId == false && error == false">
            <loading-full :status='statusmensagem' />
        </div>
        
        <div v-if="buyerId != false">

        <div class='row mt-2'>
            <div class='col-12'>
                <!-- <a class='f6 gray pointer' @click='showCardsBands = !showCardsBands' > ver cartões aceitos </a> -->
                    <div v-if='showCardsBands'>
                        <!-- <span  v-for="creditCart in acceptCreditCards">
                            <img :src='"https://stc.pagseguro.uol.com.br"+creditCart.images.SMALL.path'>
                        </span> -->
                    </div>
            </div>
        </div>

        <vue-form v-if="isCredit" name="payment" v-model="paymentInfo" validate="validatePagInfo" class='mt-2'>
            
            <div class='row'>
            
                <div class='col-12 col-lg-7 relative'>
                    <vue-field mask="#### #### #### #### ###" @change="getCardBrand"  @blur="checkCardCupom"  type="string" name="cardnumber"  label="Número do Cartão" :validations="['creditCard']" required></vue-field> 
                   
                    <span class="currentcardband" v-if="cardBrand.name" style="font-size:0.7rem;margin-right:1em; text-transform:uppercase; font-weight:bold;color:gray">{{ cardBrand.name }}</span>
                </div>

                <vue-field class='col-12 col-lg-3' type="string" name="cvv" label="CVV" required ></vue-field>
                <vue-field class='col-12 col-lg-5' type="card-valid-date" :showDay="false" name="duedate" label="Data de Validade"  required :validations="[cardValidDate]"></vue-field>
                <vue-field class='col-12 col-lg-5' type="select" :options="installmentOptions" name="installments" label="Parcelamento"  required ></vue-field>
            
            </div>
            
        </vue-form>
        
        <div class='mt-4' v-if="isCredit" >
                <a @click='customAddressBilling = ! customAddressBilling' class='pointer' style="font-size:1.1rem;font-weight:bolder;"> Informar outro Pagador  </a>
                <div class='row mt-3' v-if="customAddressBilling" key="addressbilling">
                    <div class="col-12">
                        <b>Informações do proprietário do cartão</b>
                        <hr/>
                            <vue-form  name="buyer" v-model="buyerInfo" >
                                    <vue-field  class='col-12 col-lg-6' type="string" name="name" label="Nome Completo" required></vue-field>
                                    <vue-field  class='col-12 col-lg-6' type="string" name="cpf" label="CPF" :mask="['###.###.###-##', '##.###.###/####-##']" required></vue-field>
                                    <vue-field  class='col-12 col-lg-6' type="string" name="email" label="Email" required :validations="['email']"></vue-field>
                                    <!-- <vue-field  class='col-12 col-lg-6' type="age" name="birthday" label="Data de Nascimento" required ></vue-field> -->
                                    <vue-field  class='col-12 col-lg-6' type="string" name="telephone" label="Telefone" required ></vue-field>
                                    <vue-field  class='col-12 col-lg-6' type="address" name="address" label="Endereço de cobrança" />
                            </vue-form>
                    </div>
                </div>
 
        </div>

        <!-- <pre>{{ this.$props }}</pre> -->

        </div>

    </div>   
</template>

<script>

import api from '@/api';
import moment from 'moment';
import luhn from 'luhn';
// var buscaCep = require('busca-cep');
//LETODO - includ installs and check foraccept payment types and compare with paymentOptions

var _SANDBOX = (_ENV == 'development')

import validadeFormMixins from "@/mixins/validateForms"
export default {
    mixins:[validadeFormMixins],

    props:['paymentOption','amount','value'],

    data(){
        return { 
            showCardsBands:false,
            currentCreditCardBand:false,
            sessionId:'',
            customAddressBilling:false,
            paymentInfo:{
                cardnumber:'',
                cvv:'',
                duedate:'',
                installments:1,
                billingAddressPostalCode:'',
                billingAddressStreet:'',
                billingAddressDistrict:'',
                billingAddressCity:'',
                billingAddressState:'',
                billingAddressNumber:'',
                creditCardHolderName:'',
                creditCardHolderBirthDate:'',
                creditCardHolderCPF:'',
                creditCardHolderPhone:'',
            },

            creditCardInstallmentsOptions:[], //0: [{installmentAmount: 48.45 interestFree: true, quantity: 1, totalAmount: 48.45},...]
            token:'',
            buyerId:false,
            currentCardType:'',
            scriptLoaded:false,
            error:false,
            acceptCreditCards:[],
            cardBrand:false,
            statusmensagem:'',
        }
    },


    created(){

        // if(!window.PagSeguroDirectPayment){
        //     this.loadPaymentScript()
        // }else{
        //     this.scriptLoaded = true;
        // }
        // this.startSession();
        this.getOrsetBuyerId()
        this.validateCurrentBuyerInfo()
   },

    watch:{

        //

        
        buyerId:function(val){
            var info = {buyerId:this.buyerId}
            this.$emit('input', info )
            this.$emit('change', info ) 
        },

        // cardBrand:function(val){
        //     this.paymentInfo.brand = val
        // },

        // token:function(val){

        //     let installments = this.creditCardInstallmentsOptions[ this.paymentInfo.installments - 1 ];
        //     var info = {...this.paymentInfo,
        //                 maxInstallmentNoInterest: this.paymentOption.maxInstallments,
        //                 installmentQuantity: installments.quantity,
        //                 installmentValue: installments.installmentAmount,
        //                 creditCardToken:val,
        //                 buyerId:this.buyerId,
        //     }
            
        //     this.$emit('input', info )
        //     this.$emit('change', info )
        // },

        paymentInfo:function(val, oldval){
            
            if(val.cardnumber != oldval.cardnumber){
                this.getCardBrand(val.cardnumber);
            }
            
            if(val.installments != oldval.installments){
                //LETODO - include totalTax getting from installments
                // let installments = this.creditCardInstallmentsOptions[ this.paymentInfo.installments - 1 ];
            }

            let installments = this.installmentOptions[ this.paymentInfo.installments - 1 ];
           
            var info = {...this.paymentInfo,
                        maxInstallmentNoInterest: this.paymentOption.maxInstallments,
                        installmentQuantity: installments.value,
                        // installmentValue: installments.installmentAmount,
                        buyerId:this.buyerId,
            }
            
            this.$emit('input', info )
            this.$emit('change', info )

        },

        cardBrand:function(){
            this.getInstallments()
        },


    },

    computed:{

        userInfo:function(){
            return this.$store.getters.user
        },
        // total:function(){
        //     return this.$store.getters['OrderStore'].getTotalFinal
        // },
        paymentType:function(){
            return this.paymentOption.paymentType
        },
        isBoleto:function(){
            return this.paymentOption.paymentType == "boleto"
        },
        isCredit:function(){
            return this.paymentOption.paymentType == "credit"
        },
        isPIX:function(){
            return this.paymentOption.paymentType == "pix"
        },
        paymmentProviderId:function(){
            return this.paymentOption.paymentProviderId
        },
        paymmentProviderName:function(){
            return this.paymentOption.providerId
        },
        paymentProviderUrl:function(){
            return `PaymentProviders/${this.paymmentProviderId}/${this.paymmentProviderName}`
        } ,
        
        creditCardBandImage:function(){
            //   return "https://stc.pagseguro.uol.com.br"+creditCart[this.].images.SMALL.path
        },
        dueDateMonth:function(){
            if( this.paymentInfo.duedate != ''){
                return this.paymentInfo.duedate.match(/^(\d\d\d\d)-(\d\d)/)[2]
            }else{
                return ''
            }
        },
        dueDateYear:function(){
              if( this.paymentInfo.duedate != ''){
                    return this.paymentInfo.duedate.match(/^(\d\d\d\d)-(\d\d)/)[1]
              }else{
                return ''
            }
        },

        installmentOptions:function(){
            
            let options = []

            let totalInstallments = this.paymentOption.maxInstallments || 1

            
                for(let i = 1; i <= totalInstallments; i++){
                    let value = this.orderTotal/i
                    options.push({name:`${i}x R$ ${value.toFixed(2)}`, value:i})
                }
            
            // _.each( this.creditCardInstallmentsOptions, v=>{ 
                    
            //         let percentual = v.totalAmount/this.amount/v.quantity;
            //         let name = `${v.quantity} X R$ ${v.installmentAmount} = ${v.totalAmount}`;
            //         if( v.quantity <= this.paymentOption.maxInstallments )
            //              options.push({ name, value:v.quantity })
            // } )
            return options;
        },
        
        buyerInfo:{
            set:function(val){
                
                this.$store.commit('OrderStore/updateBuyer', val)
            },
            get:function(val){
                let customBuyer = this.$store.getters['OrderStore/buyer']
                return customBuyer.name ? customBuyer : this.userInfo
            }
        },

        orderTotal:function(){
            return this.$store.getters['OrderStore/getTotalFinal']
        },


    },



    methods:{

        validateCurrentBuyerInfo:function(){
            let buyer = this.buyerInfo;
            if (!buyer.name || buyer.name.split(' ').length < 2) {
                this.customAddressBilling = true;
                this.error = 'O nome do pagador deve conter pelo menos 2 palavras';
                return false;
            }

            // if(buyer.name){
            //     this.getOrsetBuyerId()
            // }
        },

        validatePagInfo:async function(data){
            // console.log('validatePagInfo');
            // console.log(data);
            this.validateCurrentBuyerInfo();
            
        },

        creditCard:function(val){
          
            
            if(!luhn(val)){
                return ['Número do cartão inválido'];
            }
        },

        getOrsetBuyerId:async function(){
            //
            this.error = false;
            this.statusmensagem = 'gerando identificação única do comprador'
            let buyer = this.userInfo;

            let params = {
                    name:buyer.name,
                    email:buyer.email,
                    cpf:buyer.cpf,
                    telephone:buyer.telephone
                }

            let res = await api.postJSONAsync(
                `${this.paymentProviderUrl}/getOrCreateCustumer?sandbox=${_SANDBOX}`,
                params)

            if(res.error){
                if(res.status = 401){
                    this.error = 'Erro ao iniciar o pagamento (informações do comprador) - Contacte o Admministrador ';
                }else{
                    this.error = this.message;
                }
                setTimeout(this.getOrsetBuyerId,6000)
                return;
            }
            if(_.has(res,'id')){
                  this.statusmensagem = ''
                this.buyerId = _.get(res,'id')
            }

            
        },

        checkAvaliablePaymentOptions:function(){
        
            // PagSeguroDirectPayment.getPaymentMethods({
            //     amount: parseInt(this.amount,10),
            //     success: (response) => {
            //         //meios de pagamento disponíveis
            //        var credit =  _.get(response, 'paymentMethods.CREDIT_CARD',false)
            //        this.acceptCreditCards = _.get(credit,'options');

            //        //ch eck i paymentoptions is accept by pagseguro
            //     },
            //     error: function(response) {
            //          this.error = response.message;
            //         //tratamento do erro
            //     },
            //     complete: function(response) {
            //         //tratamento comum para todas chamadas
            //     }
            // });
        },

      

        getCardBrand:function(){
            let cardNumberStr = this.paymentInfo.cardnumber.toString().replace(/\D/g, '');
            if (!cardNumberStr) {
                // this.error = "Número do cartão inválido";
                return;
            }

            let cardBrand = '';

            
            if (/^4[0-9]{12}(?:[0-9]{3})?$/.test(cardNumberStr)) {
                cardBrand = 'Visa';
            } else if (/^5[1-5][0-9]{14}$/.test(cardNumberStr)) {
                cardBrand = 'MasterCard';
            } else if (/^3[47][0-9]{13}$/.test(cardNumberStr)) {
                cardBrand = 'AmericanExpress';
            } else if (/^6(?:011|5[0-9]{2})[0-9]{12}$/.test(cardNumberStr)) {
                cardBrand = 'Discover';
            } else if (/^3(?:0[0-5]|[68][0-9])[0-9]{11}$/.test(cardNumberStr)) {
                cardBrand = 'DinersClub';
            } else if (/^35[0-9]{14}$/.test(cardNumberStr)) {
                cardBrand = 'JCB';
            } else {
                // this.error = "Bandeira do cartão não suportada";
                // return;
            }


            const cardBrandSVGs = {
                Visa: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><text x="2" y="15" font-size="12" fill="black">Visa</text></svg>',
                MasterCard: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><text x="2" y="15" font-size="12" fill="black">MasterCard</text></svg>',
                AmericanExpress: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><text x="2" y="15" font-size="12" fill="black">AmEx</text></svg>',
                Discover: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><text x="2" y="15" font-size="12" fill="black">Discover</text></svg>',
                DinersClub: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><text x="2" y="15" font-size="12" fill="black">Diners</text></svg>',
                JCB: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><text x="2" y="15" font-size="12" fill="black">JCB</text></svg>'
            };

            const cardBrandSVG = cardBrandSVGs[cardBrand] || '';


            // console.log(cardBrand);
            this.cardBrand = { name: cardBrand, svg: cardBrandSVG };

         
        },

        getInstallments:function(){

        //    PagSeguroDirectPayment.getInstallments({	
        //             amount: this.amount,
        //             brand: this.cardBrand.name,
        //             maxInstallmentNoInterest: this.paymentOption.maxInstallments,
        //             success: (response) => {
        //                 //opções de parcelamento disponível
                        
        //                 console.log(response);
        //                 this.creditCardInstallmentsOptions = response.installments[this.cardBrand.name]
        //             },
        //             error: (response) => {
        //                 //tratamento do erro
        //                 this.creditCardInstallmentsOptions = []
        //             },
        //             complete: function(response) {
        //                 //tratamento comum para todas chamadas
        //             }
        //     });
        },


        getCardToken:function(){    
      
        },

        



        searchCep:async function(val){
                // console.log('mudou cep')
            
                var cep = val.replace(/\D/g, '');
                //Verifica se campo cep possui valor informado.
                if (cep != "") {
                    //Expressão regular para validar o CEP.
                    var validacep = /^[0-9]{8}$/;
                    //Valida o formato do CEP.
                    if(validacep.test(cep)) {
                
                        var url = `https://viacep.com.br/ws/${cep}/json`;
                        
                        var res = await api.getJSONAsync(url,{},true);
                        // .then(res => {
                                    //"cep": "70855-020", //   "logradouro": "SQN 407 Bloco B", //   "complemento": "", //   "bairro": "Asa Norte", //   "localidade": "Brasília", //   "uf": "DF", //   "unidade": "", //   "ibge": "5300108", //   "gia": "" // }
                        if(res.cep){
                            this.paymentInfo.billingAddressPostalCode = res.cep;
                            this.paymentInfo.billingAddressStreet = res.logradouro;
                            this.paymentInfo.billingAddressDistrict = res.bairro;
                            this.paymentInfo.billingAddressCity = res.localidade;
                            this.paymentInfo.billingAddressState = res.uf;
                        }
                        // })

                    }
                
                }
               
        },

        cardValidDate:function(val){
            
            let currentDate = moment();
            let dueDate = moment(val, "YYYY-MM-DD");
            if(!dueDate.isAfter(currentDate, 'day')){
                return ['A data não pode ser anterior a hoje'];
            }
        },


        validate:async function(){
            
            this.error = false;
            var formValid = await this.validateForms();
            if(formValid){
                //se credito, vejo se consigo pegar o token
                if(this.isCredit){
                    try{
                        if( this.cardBrand == false){
                            await this.getCardBrand();
                        }
                        //VALIDATE CREDIT CARD NUMBER
                        if(this.paymentInfo.cardnumber.length < 16){
                            this.error = "Número do cartão inválido";
                            return false;
                        }
                        // let res = await this.getCardToken();
                        return true;
                    }catch(e){
                        this.error = e.errors;
                        return false;
                    }
                }
                //se credito, vejo se consigo pegar o token
                if(this.isBoleto){
                    return true;
                }


            }else{
                return false;
            }
        
        },


        // Funcão especial so para cartao caixa

        checkCardCupom: async function(){
            // console.log('checkCardCupom',this.paymentInfo.cardnumber)
            //check if a cupom dont alread exist
            const cupom = this.$store.getters['OrderStore/cupom']
            const isCaixa = this.isCaixaCard(this.paymentInfo.cardnumber)

            // se eu tenho um cupom caixa e nao é mais cartao caixa, limpo o cupom
            if(cupom && cupom.code == 'CLIENTE_CAIXA' && !isCaixa){
                this.$store.dispatch('OrderStore/clearCupom')
                return
            }
            // se ja tenho um desconto, nao posso usar o da caixa
            if(cupom){
                // console.log('************* cupom ja existe')
                return;
            }
    
            if(isCaixa){
                // console.log('******************************************************** is caixa')
                //checko se tem um cupom valido antes de exibir no front end
                const eventid = this.$store.getters['EventStore/eventInfo'].id
                const isCupomValid = await api.getJSONAsync(`checkCupom`, {code:'CLIENTE_CAIXA', id: eventid})
                if(isCupomValid){
                    // console.log('************* is valid')
                    this.$store.dispatch('OrderStore/checkCupom','CLIENTE_CAIXA')
                    alert('Você recebeu um desconto no seu pedido por usar um cartão da Caixa Econômica Federal')
                //    alert('Cupom valido')
                }else{
                    // alert('Cupom invalido')
                }
                // this.paymentInfo.cardnumber = '5067' + this.paymentInfo.cardnumber.slice(4)

            }
        },

        isCaixaCard(val) {
            let cardNumber = val.toString().replace(/\D/g, '');
            if (cardNumber.length < 6) {
                console.error("Número de cartão inválido.");
                return false;
            }
           

            // Lista de BINs da Caixa Econômica Federal
        const caixaBins = [
        // "606282",
        "603689",
        "451412",
        "439267",
        "461142",
        "451416",
        "627780",
        "506722",
        "509023",
        "650032",
        "650077",
        "506724",
        "506741",
        "506777",
        "509023",
        "509030",
        "509044",
        "509045",
        "509047",
        "509048",
        "509050",
        "650507",
        "650507",
        "650507",
        "650507",
        "650507",
        "650512",
        "650592",
        "650594",
        "651659",
        "651670",
        "651674",
        "651677",
        "655007",
        "655007",
        "655008",
        "655008",
        "655018",
        "419597",
        "419598",
        "421958",
        "421958",
        "421959",
        "421959",
        "421960",
        "421961",
        "421963",
        "421964",
        "421964",
        "421964",
        "421965",
        "421965",
        "421965",
        "447247",
        "459360",
        "459383",
        "459383",
        "459383",
        "459384",
        "459384",
        "459384",
        "459384",
        "459385",
        "469893",
        "498515",
        "552668",
        "536269",
        "426055",
        "421962",
        "650920",
        "650965",
        "650921",
        "426055",
        "421957",
        "650950",
        "650966",
        "512682",
        "512683",
        "515787",
        "526831",
        "526959",
        "526962",
        "526965",
        "526965",
        "526966",
        "526967",
        "532817",
        "532924",
        "539016",
        "539018",
        "540593",
        "540593",
        "544817",
        "548826",
        "548827",
        "552937",
        "553096",
        "553645",
        "554932",
        "558763",
        "558763"
        ];

            // Extrair os 6 primeiros dígitos do número do cartão (BIN)
            const cardBin = cardNumber.slice(0, 6);

            // Verificar se o BIN está na lista da Caixa
            return caixaBins.includes(cardBin);
        },





    }

}
</script>

<style scoped lang="stylus">
    .currentcardband{
        position:absolute;
        right:17px;
        margin-top:-44px;
    }

</style>
